import { FormDialogProps } from '@explorer/forms/base/FormDialog';
import { CommonFormProps } from '@explorer/forms/types';
import { useFormik } from 'formik';
import { useIntl } from 'react-intl';

import { INITIAL_FORM_VALUES } from './constant';
import { FormValues, validationSchema } from './formSchema';
import { useMutationTriggerCRAScan } from './queries/useMutationTriggerCRAScan';
import { useQueryDataScanningList } from './queries/useQueryDataScanningList';
import { TriggerCRAScanForm } from './TriggerCRAScanForm';

export const TriggerCRAScan = ({
  handleClose,
  industries,
  maxWidth = 'md',
  open = false,
  querySearch = '',
}: TriggerCRAScanProps) => {
  const intl = useIntl();

  const formik = useFormik<FormValues>({
    initialValues: INITIAL_FORM_VALUES,
    validationSchema: validationSchema(intl),
    validateOnChange: false,
    onSubmit: (values) => mutate(values),
  });

  const { handleFetchData, invalidateQueries } = useQueryDataScanningList(
    querySearch,
    formik,
  );

  const { mutate } = useMutationTriggerCRAScan(
    formik,
    handleClose,
    invalidateQueries,
  );

  return (
    <TriggerCRAScanForm
      formik={formik}
      handleFetchData={handleFetchData}
      handleClose={handleClose}
      industries={industries}
      maxWidth={maxWidth}
      open={open}
    />
  );
};

export interface TriggerCRAScanProps
  extends Pick<FormDialogProps, 'open' | 'handleClose' | 'maxWidth'>,
    Omit<CommonFormProps<FormValues>, 'endpoint'> {
  industries: Options;
  querySearch?: string;
}
